import { mapGetters } from 'vuex'
import { get, map } from 'lodash-es'

export const TSCommonMixin = {
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    role() {
      return get(this.currentUser, 'customData.role')
    },
    photos() {
      return this.getPhotos(this.fluxItem)
    },
    picturesById() {
      if (!this.fluxItem) return {}

      const picsByKey = {}
      if (this.fluxItem.pictures && this.fluxItem.pictures.length > 0){
        this.fluxItem.pictures.forEach((p) => {
          picsByKey[p.id] = p
        });
      } else {
        this.photos.forEach((p, i) => {
          picsByKey[i] = {physicalPath: p}
        });
      }
      return picsByKey
    },
  },
  methods: {
    getPhotos(item) {
      if(item.pictures &&item.pictures.length > 0) {
        return map(item.pictures, 'physicalPath')
      } else if (get(item, 'rawData.img_files')) {
        if (item.source === 'leboncoin') {
          let directory =
            item.type === 'ads_cre'
              ? item.structuredData.isPro
                ? 'leboncoincreproimg'
                : 'leboncoincreimg'
              : 'lbcimg'
          return map(get(item, 'rawData.img_files'), (i) => {
            return `${process.env.VUE_APP_IMG_SERVER}/${directory}/${i.path}`
          })
        } else if (item.source === 'seloger') {
          let directory =
            item.type === 'ads_cre' ? 'selogerbureauximg' : 'selogerimg'
          return map(get(item, 'rawData.img_files'), (i) => {
            return `${process.env.VUE_APP_IMG_SERVER}/${directory}/${i.path}`
          })
        } else if (item.source === 'bellesdemeures') {
          return map(get(item, 'rawData.img_files'), (i) => {
            return `${process.env.VUE_APP_IMG_SERVER}/bellesdemeuresimg/${i.path}`
          })
        } else if (item.source === 'lefigaro') {
          return map(get(item, 'rawData.img_files'), (i) => {
            return `${process.env.VUE_APP_IMG_SERVER}/lefigaroimg/${i.path}`
          })
        } else if (item.source === 'proprietes_lefigaro') {
          return map(get(item, 'rawData.img_files'), (i) => {
            return `${process.env.VUE_APP_IMG_SERVER}/proprieteslefigaroimg/${i.path}`
          })
        } else if (item.source === 'bienici') {
          let directory =
            item.type === 'ads_cre' ? 'bienicicreimg' : 'bieniciimg'
          return map(get(item, 'rawData.img_files'), (i) => {
            return `${process.env.VUE_APP_IMG_SERVER}/${directory}/${i.path}`
          })
        }
      } else if (get(item, 'rawData.photos')) {
        return map(item.rawData.photos, 'url')
      } else if (get(item, 'rawData.img')) {
        return get(item, 'rawData.img')
      } else {
        return []
      }
    },
    getRole(role) {
      switch (role) {
        case 'ADMIN':
          return { color: 'red', icon: 'mdi-shield-check' }
        case 'VALIDATOR':
          return { color: 'primary', icon: 'mdi-account-check' }
        case 'OPERATOR':
          return { color: 'teal', icon: 'mdi-account-search' }
        default:
          break
      }
    },
  },
}
